import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { DataTable } from '../../components/Tables';
import PageHeader from '../shared/PageHeader';
import { statesApi, countriesApi, extractList } from '../../api/facades';

const StatesListPage: React.FC = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const [countryId, setCountryId] = useState<number | ''>('');

  const { data: countriesRes } = useQuery({
    queryKey: ['countries'],
    queryFn: () => countriesApi.list({ perPage: 200 }),
  });
  const countries = extractList(countriesRes);

  const { data: res, isLoading } = useQuery({
    queryKey: ['states', countryId, search],
    queryFn: () =>
      statesApi.list({
        countryId: typeof countryId === 'number' ? countryId : undefined,
        search: search || undefined,
        perPage: 50,
      }),
  });
  const rows = extractList(res);

  const columns = [
    { key: 'name', label: 'Name' },
    {
      key: 'country',
      label: 'Country',
      render: (r: any) => r.country?.name ?? r.country_name ?? '—',
    },
    {
      key: 'cities',
      label: 'Cities',
      render: (r: any) => (Array.isArray(r.cities) ? r.cities.length : r.cities_count ?? '—'),
    },
  ];

  return (
    <div>
      <PageHeader title="States" subtitle="Reference data. Read-only." />
      <div className="bg-white dark:bg-slate-800/50 rounded-2xl p-6">
        <div className="mb-4 flex flex-wrap gap-4">
        <select
          value={countryId === '' ? '' : countryId}
          onChange={(e) => setCountryId(e.target.value === '' ? '' : Number(e.target.value))}
          className="rounded-lg border border-gray-300 bg-white dark:bg-slate-800 dark:border-gray-600 py-2 px-3 text-sm text-slate-700 dark:text-slate-200 focus:border-primary-300 focus:outline-none"
        >
          <option value="">All countries</option>
          {countries.map((c: any) => (
            <option key={c.id} value={c.id}>
              {c.name}
            </option>
          ))}
        </select>
        <input
          type="search"
          placeholder="Search by state name"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="w-full max-w-xs rounded-lg border border-gray-300 bg-white dark:bg-slate-800 dark:border-gray-600 py-2 px-3 text-sm text-slate-700 dark:text-slate-200 focus:border-primary-300 focus:outline-none"
        />
      </div>
      <DataTable
        columns={columns}
        data={rows}
        loading={isLoading}
        emptyMessage="No states found."
        onRowClick={(id) => navigate(`/dashboard/settings/states/${id}`)}
        />
      </div>
    </div>
  );
};

export default StatesListPage;
